import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { createEffectFactory } from '@recruitee/ngrx';

import { FieldMappingActions } from './field-mapping.store';

@Injectable({ providedIn: 'root' })
export class FieldMappingEffects {
  public effect = createEffectFactory(FieldMappingActions, this.actions$);

  constructor(private actions$: Actions) {}
}
